/**
 * defa.views.RecipientSnippet
 * A snippet view for Recipients.
 * @version 1.0.0
 */


import Snippet from '../../poppet/snippet';
import { T }   from 'defa-object';

export const RecipientSnippet = Snippet.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	templateContext() {
		let superContext = Snippet.prototype.templateContext.call(this);
		let header = this.model.get('recipient');
		header = this.adjustHeader(header);
		
		return _.extend(superContext, {
			iconClass : this.model.get('type') === 'EMAIL'? 'icon icon-material icon-labelled icon-email': 'icon icon-material icon-labelled icon-phone' ,
			hasDelete: true,
			header    :header,
		});
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Triggers when a view is attached.
	 * @void
	 */
	onAttach: function(){
		this.ui.headerWrap.parent().addClass('recipient-snippet')
	},
	
	/**
	 * Triggers when a user clicks the delete button.
	 * The ui element for this button is inherited from poppet snippet.
	 * @void
	 */
	onClickDelete: function(event){
		event.preventDefault();
		this.model.destroy({wait: true});
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	/**
	 * Adjusts the recipient header length and text.
	 * @void
	 */
	adjustHeader: function(header){
		let generalHtml = '<span class="warning">' + T.tc('Recipients', 'General')+ '</span>';
		let emergencyHtml = '<span class="danger">' + T.tc('Recipients', 'Emergency')+ '</span>';
		
		if(header.length > 20){
			header = header.substring(0,20) + '...'
		}
		
		if(this.model.get('generalLevel') && this.model.get('emergencyLevel')){
			header += '<br>' + generalHtml + ' ' + emergencyHtml
		}
		else if(this.model.get('emergencyLevel')){
			header += '<br>' + emergencyHtml;
		}
		else if(this.model.get('generalLevel')){
			header += '<br>' + generalHtml;
		}else{
			header += '<br>' + '<span class="disabled">' +T.tc('Recipients', 'Alerts disabled')+'</span>'
		}
		return header;
	},
	
} );
export default RecipientSnippet;